<template>
  <div>
    <div v-if="dataInfo.id" style="display:flex;margin-top:-10px;margin-bottom:10px;">
      <div style="font-size:14px;color:#333;" v-if="dataInfo.id">（04之前）序列号：{{dataInfo.id}}</div>
      <div style="margin:0 24px 10px">
        <span v-if="dataInfo.status == 0" style="color:#EF7400">保存</span>
        <span v-if="dataInfo.status == 1" style="color:#EF7400">待商务审核</span>
        <span v-if="dataInfo.status == 2" style="color:#3265f3">待财务审核</span>
        <span v-if="dataInfo.status == 3" style="color:#d51313;">商务审核驳回</span>
        <span v-if="dataInfo.status == 4" style="color:#00BB5D;">财务审核通过</span>
        <span v-if="dataInfo.status == 5" style="color:#d51313;">财务审核驳回</span>
      </div>
    </div>
    <div v-if="editFlag">
      <div class="writeBox writeBox1">
        <div class="writeItem" v-for="(item,index) in must_data" :key="index">
          <label><em style="color:red">*</em>{{item.name}}</label>
          <el-input class="input" v-if="item.type=='number'" v-model="item.value" :placeholder="item.name" @input="(val)=>{clearNoNum({value:val,valueName:index,mainName:'must_data'})}" size='mini'></el-input>
          <el-date-picker v-if="item.type=='month'" class="input" v-model="item.value" size="mini" type="month" value-format="yyyy-MM" :picker-options="pickerOptionsMonth" placeholder="选择月">
          </el-date-picker>
          <el-input class="input" v-if="item.type=='text'" v-model="item.value" :placeholder="item.name" size='mini'></el-input><em v-if="item.name&&item.name.indexOf('比例')!=-1" style="font-size: 12px;color: #ff6a00;">填小数</em>
          <el-date-picker v-if="item.type=='date'" class="input" v-model="item.value" type="date" size="mini" value-format="yyyy-MM-dd" placeholder="选择日期">
          </el-date-picker>
        </div>
      </div>
      <div class="writeBox">
        <div class="writeItem" v-for="(item,index) in no_must_data" :key="index">
          <label>{{item.name}}</label>
          <el-input class="input" v-if="item.type=='number'" v-model="item.value" :placeholder="item.name" @input="(val)=>{clearNoNum({value:val,valueName:index,mainName:'no_must_data'})}" size='mini'></el-input>
          <el-date-picker v-if="item.type=='month'" class="input" v-model="item.value" size="mini" type="month" value-format="yyyy-MM" :picker-options="pickerOptionsMonth" placeholder="选择月">
          </el-date-picker>
          <el-input class="input" v-if="item.type=='text'" v-model="item.value" :placeholder="item.name" size='mini'></el-input><em v-if="item.name&&item.name.indexOf('比例')!=-1" style="font-size: 12px;color: #ff6a00;">填小数</em>
          <el-date-picker v-if="item.type=='date'" class="input" v-model="item.value" type="date" size="mini" value-format="yyyy-MM-dd" placeholder="选择日期">
          </el-date-picker>
        </div>
        <div class="writeItem">
          <label>是否对公</label>
          <el-checkbox v-model="if_public">是</el-checkbox>
        </div>
        <div class="writeItem">
          <label>是否返货</label>
          <el-checkbox v-model="is_pdd_refund">是</el-checkbox>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="writeBox calculation writeBox1">
        <div class="writeItem" v-for="(item,index) in must_data" :key="index">
          <label>{{item.name}}：</label>
          <span>{{item.value}}</span>
        </div>
      </div>
      <div class="writeBox calculation">
        <div class="writeItem" v-for="(item,index) in no_must_data" :key="index">
          <label>{{item.name}}：</label>
          <span>{{item.value}}</span>
        </div>
        <div class="writeItem">
          <label>是否对公：</label>
          <span>{{if_public?'是':'否'}}</span>
        </div>
        <div class="writeItem">
          <label>是否返货：</label>
          <span>{{is_pdd_refund?'是':'否'}}</span>
        </div>
      </div>
    </div>
    <div class="examine">
      <div v-if="dataInfo.status&&dataInfo.status!=1&&dataInfo.status!=0" style="margin:5px 0">
        <div style="margin:5px 0">
          <label>商务审核人：</label>
          <span style="color:#5E5F6B;font-size:14px;">{{dataInfo.verify_user}}</span>
        </div>
        <div style="margin:5px 0">
          <label>商务审核时间：</label>
          <span style="color:#5E5F6B;font-size:14px;">{{dataInfo.verify_at}}</span>
        </div>
        <div style="margin:5px 0">
          <label>商务审核备注：</label>
          <span style="color:#5E5F6B;font-size:14px;">{{dataInfo.verify_note}}</span>
        </div>
      </div>
      <div v-if="dataInfo.status==4||dataInfo.status==5" style="margin:5px 0">
        <div style="margin:5px 0">
          <label>财务审核人：</label>
          <span style="color:#5E5F6B;font-size:14px;">{{dataInfo.cw_verify_user}}</span>
        </div>
        <div style="margin:5px 0">
          <label>财务审核时间：</label>
          <span style="color:#5E5F6B;font-size:14px;">{{dataInfo.cw_verify_at}}</span>
        </div>
        <div style="margin:5px 0">
          <label>财务审核备注：</label>
          <span style="color:#5E5F6B;font-size:14px;">{{dataInfo.cw_verify_note}}</span>
        </div>
      </div>
      <div style="margin:5px 0" class="no-print" v-if="(userInfo.role_id == 15 && dataInfo.status == 1) || (userInfo.role_id == 10 && dataInfo.status == 2)">
        <label style="vertical-align: top;">审核备注：</label>
        <el-input class="textarea" type="textarea" placeholder="请输入审核原因" v-model="op_reason">
        </el-input>
      </div>
    </div>
    <div class="buttones">
      <div v-if="(userInfo.role_id == 15 && dataInfo.status == 1) || (userInfo.role_id == 10 && dataInfo.status == 2)" style="display:inline-block">
        <button class="yes" @click="orderVerify(1)">审核通过</button>
        <button class="yes" @click="orderVerify(2)" style="background:#d51313;border-color:#d51313">审核不通过</button>
      </div>
      <div v-if="editFlag" style="display:inline-block">
        <button class="yes" @click="orderUpdate(0)">保存</button>
        <button class="yes" @click="orderUpdate(1)">提交审核</button>
      </div>
      <button @click="orderCancelClick">取消</button>
    </div>
  </div>
</template>
<script>
export default {
  props: ['dataInfo'],
  data () {
    return {
      pickerOptionsMonth: {
        disabledDate (time) {
          return time.getTime() > new Date('2021-03-31 00:00:00');
        },
      },
      must_data: {
        month: { value: '', type: 'month', name: '月份' },
        company: { value: '', type: 'text', name: '签约公司' },
        salesman: { value: '', type: 'text', name: '销售人员' },
        handler: { value: '', type: 'text', name: '经手人' },
        origin_customer_name: { value: '', type: 'text', name: '当月客户全称' },
        customer_name: { value: '', type: 'text', name: '客户全称' },
        project_name: { value: '', type: 'text', name: '项目名称' },
        launch_platform: { value: '', type: 'text', name: '投放平台' },
        media_name: { value: '', type: 'text', name: '媒体名称' },
      },
      no_must_data: {
        task_id: { value: '', type: 'text', name: '任务ID' },
        internet_celebrity_name: { value: '', type: 'text', name: '网红名称' },
        internet_celebrity_id: { value: '', type: 'text', name: '网红ID' },
        amount: { value: '', type: 'number', name: '订单金额' },
        origin_amount: { value: '', type: 'number', name: '当月最终订单金额' },
        final_amount: { value: '', type: 'number', name: '订单最终收入金额' },
        launch_start_date: { value: '', type: 'date', name: '投放起始日期' },
        launch_end_date: { value: '', type: 'date', name: '投放截止日期' },
        cost_company_name: { value: '', type: 'text', name: '成本公司全称' },
        cost: { value: '', type: 'number', name: '订单成本消耗' },
        traffic_boost_sum: { value: '', type: 'number', name: '流浪助推合计' },
        traffic_boost_refund: { value: '', type: 'number', name: '流量助推(使用返货)' },
        traffic_boost_money: { value: '', type: 'number', name: '流量助推(使用现金)' },
        top_fee: { value: '', type: 'number', name: '置顶费' },
        actual_cost_sum: { value: '', type: 'number', name: '后台实付成本金额' },
        cost_invoice_date: { value: '', type: 'date', name: '成本开票日期' },
        confirmed_cost_includes_tax: { value: '', type: 'number', name: '确认成本(含税)发票金额' },
        confirmed_cost: { value: '', type: 'number', name: '确认成本(不含税)' },
        cost_owner: { value: '', type: 'text', name: '成本负责人' },
        offline_subsidy_amount: { value: '', type: 'number', name: '线下补款金额' },
        rebate: { value: '', type: 'number', name: '补款总额(含税)' },
        offline_subsidy_company: { value: '', type: 'text', name: '线下付款公司' },
        final_ratio_of_consumption_to_top_rebate: { value: '', type: 'number', name: '消耗与置顶返点比例' },
        final_ratio_of_consumption_to_top_income: { value: '', type: 'number', name: '消耗与置顶返点收入' },
        final_flow_boost_rebate_ratio: { value: '', type: 'number', name: '流量助推返点比例' },
        final_flow_boost_rebate_income: { value: '', type: 'number', name: '流量助推返点收入' },
        rebate_total: { value: '', type: 'number', name: '返点合计' },
        rebate_spending_ratio: { value: '', type: 'number', name: '返点支出比例(按收入)' },
        rebate_spending_amount: { value: '', type: 'number', name: '返点支出金额' },
        rebate_expense_receiving_unit: { value: '', type: 'text', name: '返点支出收款单位' },
        note: { value: '', type: 'text', name: '备注' },
        mcn_name: { value: '', type: 'text', name: 'mcn返点机构全称/CA个人返点' },
        // organization_amount:{value:'', type:'number', name:'机构到手金额' },
        mcn_rebate: { value: '', type: 'number', name: 'mcn返点金额' },
        mcn_final_amount: { value: '', type: 'number', name: 'mcn最终收入金额' },
        mcn_handler: { value: '', type: 'text', name: 'mcn经手人' },
        mcn_user: { value: '', type: 'text', name: 'mcn负责人' },
        offline_cost_invoice_date: { value: '', type: 'date', name: '线下成本发票日期' },
        mcn_invoice_amount: { value: '', type: 'number', name: 'mcn开票金额' },
        mcn_invoice_date: { value: '', type: 'date', name: 'mcn开票日期' },
        offline_cost_invoice_amount: { value: '', type: 'number', name: '线下成本发票金额' },
      },
      if_public: false,
      is_pdd_refund: false,
      op_reason: '',
      editFlag: false,
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    if (this.dataInfo && this.dataInfo.id) {
      for (var i in this.must_data) { this.must_data[i].value = this.dataInfo[i] }
      for (var i in this.no_must_data) {
        if (i == 'final_ratio_of_consumption_to_top_rebate' || i == 'final_flow_boost_rebate_ratio') {
          if (this.dataInfo[i] == "%") {
            this.no_must_data[i].value = ''
          } else {
            this.no_must_data[i].value = parseFloat((parseFloat(this.dataInfo[i]) / 100))
          }
        } else {
          this.no_must_data[i].value = this.dataInfo[i]
        }
      }
      this.if_public = this.dataInfo.if_public == '是' ? true : false
      this.is_pdd_refund = this.dataInfo.is_pdd_refund == '是' ? true : false
    }
    if ((!this.dataInfo.id || this.dataInfo.status == 0 || this.dataInfo.status == 3 || this.dataInfo.status == 5) && this.userInfo.role_id != 10 && this.userInfo.role_id != 15) {
      this.editFlag = true
    } else {
      this.editFlag = false
    }
  },
  methods: {
    clearNoNum ({ value, valueName, mainName }) {//判断只能输入纯数字或者小数点，及负整数
      var t = value.charAt(0);
      //先把非数字的都替换掉，除了数字和.
      value = value.replace(/[^\d.]/g, "");
      //必须保证第一个为数字而不是.
      value = value.replace(/^\./g, "");
      //保证只有出现一个.而没有多个.
      value = value.replace(/\.{2,}/g, ".");
      //保证.只出现一次，而不能出现两次以上
      value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      //如果第一位是负号，则允许添加   如果不允许添加负号 可以把这块注释掉
      if (t == '-') {
        value = '-' + value;
      }
      this[mainName][valueName].value = value
    },
    orderCancelClick () {
      this.$emit('cancelToast')
    },
    orderUpdate (type) {//编辑订单
      for (var i in this.must_data) {
        if (this.must_data[i].value == '') {
          this.$message({
            message: '请输入' + this.must_data[i].name,
            type: 'warning'
          })
          return
        }
      }
      var params = {
        is_pdd_refund: this.is_pdd_refund ? 1 : 0,
        if_public: this.if_public ? 1 : 0,
        type: type
      }
      var axios_api = this.URL.past_add;
      if (this.dataInfo.id && (this.dataInfo.status == 0 || this.dataInfo.status == 3 || this.dataInfo.status == 5)) {
        axios_api = this.URL.past_update;
        params.id = this.dataInfo.id
      }
      for (var i in this.must_data) { params[i] = this.must_data[i].value }
      for (var i in this.no_must_data) { params[i] = this.no_must_data[i].value }

      this.$loading(this.$loadingConfig)
      this.$axios.post(this.URL.BASEURL + axios_api, params).then((res) => {
        var res = res.data;
        this.$loading(this.$loadingConfig).close()
        if (res && res.errno == 0) {
          this.$alert('操作成功！', '成功', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            callback: action => {
              this.$emit('emit_refresh')
            }
          });
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close()
      })
    },
    orderVerify (type) {
      if (this.op_reason == '' && type == 2) {
        this.$message({
          message: '请输入审核意见',
          type: 'warning'
        })
        return
      }
      this.$loading(this.$loadingConfig)
      this.$axios.post(this.URL.BASEURL + this.URL.past_orderVerify, {
        id: this.dataInfo.id,
        type: type,
        verify_note: this.op_reason
      }).then((res) => {
        var res = res.data;
        this.$loading(this.$loadingConfig).close()
        if (res && res.errno == 0) {
          this.$message({
            message: '审核成功',
            type: 'success'
          })
          this.$emit('emit_refresh')
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close()
      })
    },
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>
@import "@/components/Order/medium/edit.scss";
.writeBox .writeItem {
  width: 33%;
}
.writeBox .writeItem label {
  width: 102px;
}
.calculation .writeItem label {
  width: auto;
}
.textarea {
  display: inline-block;
  width: 500px;
}
.examine {
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/BeforeApril/order/add_order.vue